export function basisPointsToPercentage(basisPoints: number): number {
  return basisPoints / 100;
}
